import { useState, type CSSProperties } from "react";
import desertImage from "../assets/desert.webp";
import desertImageTwo from "../assets/desert2.webp";

export function DesertLandscape() {
  const [backgroundImage] = useState(() =>
    Math.random() < 0.5 ? desertImage : desertImageTwo,
  );

  return (
    <div
      className="desert-landscape"
      style={{ "--desert-background": `url(${backgroundImage})` } as CSSProperties}
      aria-hidden="true"
    />
  );
}
